<template>
  <div>
    <div class="flex mb-5">
      <div class="w-10/12">
        <h1 class="text-xl font-bold text-gray-700">Pending Orders</h1>
      </div>
      <div class="w-2/12">
        <base-button-primary-small @click="checkForNew"
          >Check for new</base-button-primary-small
        >
      </div>
    </div>

    <el-table
      :data="pending"
      :default-sort="{ prop: 'name', order: 'ascending' }"
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="100" sortable>
        <template slot-scope="scope">
          <span
            class="cursor-pointer text-blue-600"
            @click="navigateToDetail(scope.row)"
          >
            {{ scope.row.id }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Name" width="225" sortable>
      </el-table-column>
      <el-table-column prop="email" label="Email" width="225" sortable>
      </el-table-column>
      <el-table-column label="Total" width="100" sortable>
        <template slot-scope="scope">
          $ {{ (scope.row.total / 100) | numberFormat("0.00") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="425">
        <template slot-scope="scope">
          <base-button-primary-extra-small @click="handleRelease(scope.row)">
            Release
          </base-button-primary-extra-small>
          <base-button-white-extra-small
            @click="handleEdit(scope.row)"
            class="ml-3"
          >
            Edit Email
          </base-button-white-extra-small>
          <base-button-white-extra-small
            @click="handleNote(scope.row)"
            class="ml-3"
          >
            Note
          </base-button-white-extra-small>
          <base-button-white-extra-small
            @click="handleDiscount(scope.row)"
            class="ml-3"
          >
            Discount
          </base-button-white-extra-small>
          <base-button-white-extra-small
            @click="handleCancel(scope.row)"
            class="ml-3"
          >
            Cancel
          </base-button-white-extra-small>
        </template>
      </el-table-column>
    </el-table>

    <change-order-email
      :show-modal="emailModal"
      :email-data="emailData"
      @saved="handleSaved"
      @close="emailModal = false"
    ></change-order-email>

    <add-note
      :show-modal="noteModal"
      :new-data="noteData"
      @saved="handleNoteSaved"
      @close="noteModal = false"
    ></add-note>

    <add-discount
      :show-modal="discountModal"
      :discount-name="discountData.name"
      :order-id="discountData.orderId"
      @saved="handleDiscountSaved"
      @close="discountModal = false"
    ></add-discount>
  </div>
</template>

<script>
import ChangeOrderEmail from "../common/ChangeOrderEmail";
import BaseButtonPrimarySmall from "../ui/buttons/BaseButtonPrimarySmall";
import AddNote from "../common/AddNote";
import AddDiscount from "../common/AddDiscount";
export default {
  name: "PendingOrders",
  components: {
    AddDiscount,
    AddNote,
    BaseButtonPrimarySmall,
    ChangeOrderEmail,
  },
  data() {
    return {
      emailModal: false,
      emailData: {
        id: null,
        email: "",
      },
      noteData: {
        id: null,
        note: "",
      },
      noteModal: false,
      discountData: {
        orderId: null,
        name: "",
      },
      discountModal: false,
    };
  },
  methods: {
    navigateToDetail(row) {
      this.$router.push("/dashboard/order-detail/" + row.id);
    },
    checkForNew() {
      this.$notify({
        title: "Order",
        message: "Checking for new pending orders",
        type: "success",
      });
      this.getPending();
    },
    handleRelease(row) {
      this.$store.dispatch("order/release", row.id).then((resp) => {
        if (!resp.success) return;

        this.getPending();
        this.$notify({
          title: "Order",
          message: "This order has been released",
          type: "success",
        });
      });
    },
    handleEdit(row) {
      this.emailData.id = row.id;
      this.emailData.email = row.email;
      this.emailModal = true;
    },
    handleNote(row) {
      this.noteData.id = row.id;
      this.noteData.note = row.notes;
      this.noteModal = true;
    },
    handleDiscount(row) {
      this.discountData.orderId = row.id;
      this.discountData.name = row.discount ? row.discount.name : "";
      this.discountModal = true;
    },
    handleSaved() {
      this.emailData = {
        id: null,
        email: null,
      };
      this.emailModal = false;
      this.getPending();
    },
    handleNoteSaved() {
      this.noteData = {
        id: null,
        note: "",
      };
      this.noteModal = false;
      this.getPending();
    },
    handleDiscountSaved() {
      this.discountData = {
        orderId: null,
        name: "",
      };
      this.discountModal = false;
      this.getPending();
    },
    handleCancel(row) {
      if (confirm("Are you sure you want to cancel this order?")) {
        this.$store.dispatch("order/cancel", row.id).then((resp) => {
          if (!resp.success) return;

          this.getPending();
          this.$notify({
            title: "Order",
            message: "This order has been canceled",
            type: "success",
          });
        });
      }
    },
    getPending() {
      this.$store
        .dispatch("auth/set_outfitter_id", null)
        .then((outfitter_id) => {
          this.$store.dispatch("order/get_pending", outfitter_id);
        });
    },
  },
  computed: {
    pending: function () {
      return this.$store.getters["order/getPending"];
    },
  },
  mounted() {
    this.getPending();
  },
};
</script>

<style scoped></style>
